<script>
import {mapGetters} from "vuex";

export default {
  name: "SingleLessonWrapper",
  props: {
    lessonLink: {
      default: null,
    },
    courseLink: {
      default: null,
    },
  },
  data() {
    return {
      lesson: {},
      access: false,
      form: {}
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    })
  },
  methods: {
    async setLesson() {
      let lesson = {};
      if (this.lessonLink == null && this.courseSlug == null) {
        this.form = {
          courseSlug: this.$route.params.courseSlug,
          lessonSlug: this.$route.params.slug,
        }

        lesson = await this.$store.dispatch("Content/getContentWithoutState", this.form.lessonSlug)
      } else {

        this.form = {
          courseSlug: this.courseLink,
          lessonSlug: this.lessonLink,
        }

        lesson = await this.$store.dispatch("Content/getContentWithoutState", this.form.lessonSlug)

      }


      this.lesson = lesson.data.data;
      this.$emit('lesson', this.lesson)

    },
    async checkAccess() {
      console.log(this.lesson.free, ' in access')
      if (this.lesson.free == 0) {
        if (this.isAuthenticated) {
          // check access

          const access = await this.$store.dispatch('Content/getUserAccessToCourseWithoutState', this.form);

          this.access = access.data.data

          if (this.access == true) {
            const lesson_after_access = await this.$store.dispatch("Content/getLessonWithoutState", this.form)
            this.lesson = lesson_after_access.data.data
            this.$emit('lesson', this.lesson)
          }

        }
      } else {
        this.access = true
      }

      this.$emit('access', this.access)

    }
  },
  render() {
    return this.$scopedSlots.default({
      lesson: this.lesson,
      authenticated: this.isAuthenticated,
      access: this.access,
      courseSlug: this.form.courseSlug,
      lessonSlug: this.form.lessonSlug,
    });
  },
  async mounted() {


    await this.setLesson();

    await this.checkAccess();


  },
}
</script>
